import { EllipsedText, FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { ParagraphMedium, ParagraphSmall } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { assetStateByIdent } from '../../storage/assets';
import { EvidenceMedia } from '../../types/evidences';
import EvidenceMediaOriginTag from '../shared/evidences/EvidenceMediaOriginTag';

type Props = { media: EvidenceMedia; actions?: React.ReactNode };

const EvidenceMediaHeader = ({ media, actions }: Readonly<Props>) => {
  const { theme, classes, css } = useStyles();
  const assetByIdent = useRecoilValue(assetStateByIdent(media?.ident ?? ''));
  const assetLabel = media.asset?.label || assetByIdent?.label;

  return (
    <FlexColumn
      gap={!actions ? theme.sizing.scale100 : 0}
      classNames={css({ width: '100%' })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredBetween}
      >
        <FlexRow
          gap={theme.sizing.scale200}
          centered
        >
          <ParagraphMedium
            margin={0}
            style={{ fontWeight: '700' }}
          >
            <EllipsedText
              inline
              breakAll
            >
              {media.ident}
            </EllipsedText>
          </ParagraphMedium>
          <EvidenceMediaOriginTag origin={media.mediaOrigin} />
        </FlexRow>
        {actions}
      </FlexRow>
      {assetLabel && assetLabel.length > 0 && (
        <ParagraphSmall
          margin={0}
          color={theme.colors.contentSecondary}
          style={{ fontWeight: '500' }}
        >
          ({assetLabel})
        </ParagraphSmall>
      )}
    </FlexColumn>
  );
};

export default EvidenceMediaHeader;
